import { render, staticRenderFns } from "./CertificateHorizontal.vue?vue&type=template&id=04d955fc&scoped=true"
import script from "./CertificateHorizontal.vue?vue&type=script&lang=js"
export * from "./CertificateHorizontal.vue?vue&type=script&lang=js"
import style0 from "./CertificateHorizontal.vue?vue&type=style&index=0&id=04d955fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d955fc",
  null
  
)

export default component.exports